module.exports = __webpack_public_path__ + "static/media/human.6cf8fbdb.png";